import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette, typography }) =>
  createStyles({
    container: {
      margin: '2rem 0.8rem',
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      flex: 1,

      '& h1': {
        fontWeight: 600,
      },
    },

    inputsContainer: {
      marginTop: '4rem',

      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',

      '& .MuiTextField-root': {
        margin: 0,
        width: '100%',
      },
    },

    menuList: {
      '& > li': {
        fontSize: '1.4rem',
        color: palette.secondary.main,
        padding: '1rem 1.4rem',
        lineHeight: '2rem',
      },
      '& .MuiListSubheader-root': {
        fontWeight: 600,
        fontFamily: typography.body1.fontFamily,
      },
    },

    buttonsContainer: {
      marginTop: 'auto',

      display: 'flex',
      justifyContent: 'space-between',
      gap: '1rem',

      '& > button': {
        margin: 0,
        width: 'fit-content',
      },
    },
  }),
)
